<template>
  <div @dragend="dragEnd($event)" style="background-color:#efefef;position:relative;">
    <v-card
      ref="thisBoard"
      style="margin:10px; "
      width="250"
      height="300"
      outlined
      draggable="true"
      @dragstart="dragStart"
      data-is-board-card="true"
      :data-board-id="board.id"
    >
      <v-card-text>
        <div style="display:flex">
          <router-link :to="'/boards/' + board.id" style="margin-top: 10px; margin-right: 20px;">
            <v-btn class="mx-2" fab dark x-small color="blue" title="enter board">
              <v-icon>mdi-location-enter</v-icon>
            </v-btn>
          </router-link>
          <v-text-field
            style="width:150px"
            v-model="board.title"
            v-on:keydown="keydownBoard($event, board)"
            :errorMessages="
                (board.title !== board.orig.title && ['uncommitted']) || []
              "
            required
          ></v-text-field>
        </div>

        <div class="text--caption">
          tasks: tot: {{ board["count(*)"] || 0 }} - done:
          {{ board["sum(done)"] || 0 }}
        </div>
        <br />
        <div class="text--caption">
          last task:
          <div />
          updated:
          {{
          board["max(updated)"]
          ? new Date(board["max(updated)"]).toLocaleString()
          : "N/A"
          }}
          created:
          {{
          board["max(created)"]
          ? new Date(board["max(created)"]).toLocaleString()
          : "N/A"
          }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="board.role === 'owner'"
          v-on:click="deleteBoard(board)"
          class="mx-2"
          fab
          dark
          x-small
          color="red"
          title="delete board"
        >
          <v-icon>mdi-delete-empty</v-icon>
        </v-btn>
        <v-btn
          v-on:click="leaveBoard(board)"
          class="mx-2"
          fab
          dark
          x-small
          color="deep-orange"
          title="leave board"
        >
          <v-icon>mdi-account-off-outline</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    <div
      v-if="boardDragging && boardDragging != board"
      @dragleave="dragLeave($event)"
      @dragover="dragOver($event)"
      @drop="drop($event)"
      style="position:absolute; top:0; width:100%; height:100%; background-color:orange; opacity:0.101"
    ></div>
  </div>
</template>

<script>
import * as api from "./api";

export default {
  name: "BoardCard",
  components: {},
  props: {
    board: Object,
    boards: Array,
    boardDragging: Object,
  },
  data: () => ({}),
  computed: {},
  methods: {
    async drop() {
      const draggingBoard = this.boardDragging;
      draggingBoard.ordinal = this.board.ordinal - 50;
      const boardIds = this.boards
        .sort((a, b) => a.ordinal - b.ordinal)
        .map((b) => b.id);
      await api.reorderBoards(boardIds);
      this.$emit("boardsChanged");
      this.$refs.thisBoard.$el.parentElement.style.zIndex = "0";
      this.$refs.thisBoard.$el.style.left = "0px";
    },
    dragOver(e) {
      e.preventDefault();
      this.$refs.thisBoard.$el.style.left = "150px";
      this.$refs.thisBoard.$el.parentElement.style.zIndex = "200";
    },
    dragLeave() {
      this.$refs.thisBoard.$el.parentElement.style.zIndex = "0";
      this.$refs.thisBoard.$el.style.left = "0px";
    },
    dragStart() {
      this.$emit("startBoardDragging", this.board);
    },
    dragEnd() {
      this.$emit("endBoardDragging");
      window.boardDragging = false;
    },
    async leaveBoard(b) {
      if (confirm(`are you sure you want to leave ${b.title}?`)) {
        await api.leaveBoard(b);
        this.$emit("boardsChanged");
      }
    },
    async deleteBoard(b) {
      if (confirm(`are you sure you want to delete ${b.title}?`)) {
        await api.deleteBoard(b);
        this.$emit("boardsChanged");
      }
    },
    async keydownBoard(e, board) {
      if (e.key === "Enter") {
        e.preventDefault();
        await api.updateBoard(board);
        this.$emit("boardsChanged");
      }
    },
  },
};
</script>
